import { createElement, forwardRef, cloneElement, RefObject } from 'react';
import { Icon } from '../Icon';
import { Label } from '../Label';
import { TreeTableNodeProps } from './types';
import { renderInlineCssVars } from '../../theme';
import { TreeExpandClosed, TreeExpandOpened } from '@sas/react-svg';
import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import bundle from './NovaComponents-TreeTable-gui-icu.properties';

// Import CSS last
import cn from './TreeTableNode.css.json';
import './TreeTableNode.css';

const useTextLocalizer = createUseTextLocalizer(bundle);

export const TreeTableNode = forwardRef<RefObject<any>, TreeTableNodeProps>((props, ref) => {
  const localize = useTextLocalizer();

  function onArrowClick(e: React.MouseEvent<HTMLSpanElement>) {
    e.stopPropagation();
    if (props.onArrowClick) props.onArrowClick(props.node.id);
  }

  const nodeLabelStyle = renderInlineCssVars({
    'label-fg': props.disabled ? 'var(--tree-disabled-fg)' : 'var(--tree-fg)',
    'label-text-cursor': 'default',
  });

  const hasChildren =
    props.hasChildren || (Array.isArray(props.node.children) && props.node.children.length > 0);

  return (
    <div className={cn.item} data-testid={props.testId}>
      {hasChildren ? (
        <Icon
          tabIndex={-1}
          role="button"
          disabled={props.expandCollapseDisabled}
          ariaLabel={
            props.expanded
              ? `${localize('collapse.msg')}, ${props.node.text}`
              : `${localize('expand.msg')}, ${props.node.text}`
          }
          onClick={onArrowClick}
          className={cn.expandIcon}
          icon={props.expanded ? TreeExpandOpened : TreeExpandClosed}
          testId={'expandIcon'}
          tokens={() => {
            return {
              fg: 'var(--tree-fg)',
            };
          }}
        />
      ) : null}
      {props.selectionControl}
      {props.node.icon ? (
        <Icon
          className={cn.nodeIcon}
          {...('icon' in props.node.icon ? { ...props.node.icon } : { icon: props.node.icon })}
        />
      ) : null}
      {props.nodeElement ? (
        cloneElement(props.nodeElement, { ref, id: props.labelId })
      ) : (
        <Label
          required={!!props.node.required}
          wrapText={false}
          className={cn.nodeLabel}
          style={{ ...nodeLabelStyle, width: '100%' }}
          disabled={props.disabled}
          suppressTooltip={props.suppressTooltip}
          id={props.labelId}
        >
          {props.node.text}
        </Label>
      )}
    </div>
  );
});
